<template>
  <div class="topclass">
    <van-tabbar
      v-if="show"
      v-model="active"
      active-color="#e7b58e"
      :border="true"
      inactive-color="#929292"
      style="
        height: 4rem;
        /* border-top: 2px solid #423c3e; */
        z-index: 99;
        border-radius: 3rem;
        width: 92%;
        margin: 10px 10px;
        padding: 5px 5px !important;
      "
    >
      <!-- 首页 -->
      <van-tabbar-item
        to="/home"
        :class="active === 0 ? 'bc-router' : 'bc-noroute'"
      >
        <span>{{ $t("foorter.index") }}</span>
        <template #icon>
          <img
            :src="
              active === 0 ? '/img/footer/new1.png' : '/img/footer/new1.png'
            "
            style="height: 2rem"
          />
        </template>
      </van-tabbar-item>

      <!-- 黑料 / 订阅 -->
      <van-tabbar-item
        to="/history"
        :class="active === 1 ? 'bc-router' : 'bc-noroute'"
      >
        <span>{{ $t("foorter.subscribe") }}</span>
        <template #icon>
          <img
            :src="
              active === 1
                ? '/img/footer/new2.png'
                : '/img/footer/new2.png'
            "
            style="height: 1.8rem"
          />
        </template>
      </van-tabbar-item>

      <!-- 投注 【重点：拼接参数】 -->
      <van-tabbar-item
        :to="`/Lottery?key=${gameitem[0]?.key || ''}&id=${
          gameitem[0]?.id || ''
        }`"
        :class="active === 2 ? 'bc-router' : 'bc-noroute'"
      >
        <span>{{ $t("foorter.video") }}</span>
        <template #icon>
          <img
            :src="
              active === 2 ? '/img/footer/new3.png' : '/img/footer/new3.png'
            "
            style="height: 1.9rem"
          />
        </template>
      </van-tabbar-item>

      <!-- 选妃 -->
      <van-tabbar-item
        to="/choose"
        :class="active === 3 ? 'bc-router' : 'bc-noroute'"
      >
        <span>{{ $t("concubine.concubine") }}</span>
        <template #icon>
          <img
            :src="
              active === 3
                ? '/img/footer/new4.png'
                : '/img/footer/new4.png'
            "
            style="height: 1.8rem"
          />
        </template>
      </van-tabbar-item>

      <!-- 我的 -->
      <van-tabbar-item
        to="/mine"
        :class="active === 4 ? 'bc-router' : 'bc-noroute'"
      >
        <span>{{ $t("foorter.my") }}</span>
        <template #icon>
          <img
            :src="active === 4 ? '/img/footer/new5.png' : '/img/footer/new5.png'"
            style="height: 1.8rem"
          />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      active: 0,
      // 接口返回为数组，初始为空数组
      gameitem: [],
    };
  },
  props: {
    is_show: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    // 初始化匹配当前页面高亮
    this.setActiveByRoute(this.$route.name);
    // 初始化请求接口，拿到 key id
    this.getGameItem();
    if (this.is_show) {
      this.show = true;
    }
  },
  watch: {
    // 路由切换自动切换tab高亮
    $route(to) {
      this.setActiveByRoute(to.name);
    },
  },
  methods: {
    // 获取彩票默认配置参数
    getGameItem() {
      this.$http({
        method: "get",
        url: "lottery_list",
      }).then((res) => {
        this.gameitem = res.data || [];
      });
    },
    // 根据路由name切换tab
    setActiveByRoute(name) {
      switch (name) {
        case "home":
          this.active = 0;
          this.show = true;
          break;
        case "history":
          this.active = 1;
          this.show = true;
          break;
        case "Lottery":
          this.active = 2;
          this.show = true;
          break;
        case "choose":
          this.active = 3;
          this.show = true;
          break;
        case "mine":
          this.active = 4;
          this.show = true;
          break;
        default:
          this.show = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/base.less";


@tabbar-height: 110px;
@tabbar-img: 40px;

.topclass{
  width: 100%;
  /* 上下留白：底部20px，左右边距16px，完美裁剪不贴边 */
  padding: 1rem;
  z-index: 99;
  background: transparent;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}
.van-tabbar {
  height: @tabbar-height;
  background: rgba(0,0,0,0.5) !important;
  border: 1px solid #444;
}
.van-tabbar-item--active {
  background-color: transparent;
}
.van-tabbar-item__icon img {
  height: @tabbar-img;
}
.van-tabbar-item {
  font-size: 26px;
}
[class*="van-hairline"]::after {
  border: none !important;
}

/* 选中样式 */
.bc-router {
  background: linear-gradient(to bottom, #362c2b, #241d25) !important;
  border-radius: 3rem;
  padding: 0rem 0.3rem;
}
.bc-noroute {
  background: none !important;
}
span {
  font-weight: lighter !important;
  font-size: 0.8rem;
}
</style>